/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesBootstrapPriceListsResponseDto } from '../../models/sales-bootstrap-price-lists-response-dto';

export interface PriceListsControllerBootstrapPriceLists$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
}

export function priceListsControllerBootstrapPriceLists(http: HttpClient, rootUrl: string, params: PriceListsControllerBootstrapPriceLists$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesBootstrapPriceListsResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, priceListsControllerBootstrapPriceLists.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesBootstrapPriceListsResponseDto>;
    })
  );
}

priceListsControllerBootstrapPriceLists.PATH = '/o2-sales/price-lists/bootstrap/{tenant}';
